import { Component, OnInit, Injector, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataGridTemplate } from '../../../../../app/shared/data-grid/data-grid.template';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { GAWorkOrderService, BodyWorkOrderService, ProgramDetailsGAService } from '../../ve.service';
import { WorkOrdersService } from '../work-orders.service';
import { ReportsService } from '../../work-orders/GA/forms/reports/reports.service';
import { AuthenticationService } from '../../../../auth.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { WorkOrderCopyDialogComponent } from '../dialogs/work-order-copy-dialog/work-order-copy-dialog.component';
import { WorkOrdersFilterService } from '../work-orders-filter.service';
import { WorkOrderProgramDialogComponent } from '../dialogs/work-order-program-dialog/work-order-program-dialog.component';
import { WorkOrderSearchDialogComponent } from '../dialogs/work-order-search-dialog/work-order-search-dialog.component';
import { BodyWoSubmitReportDialogComponent } from '../Body/dialogs/body-wo-submit-report-dialog/body-wo-submit-report-dialog.component';
import { GaWoSubmitReportDialogComponent } from '../GA/dialogs/ga-wo-submit-report-dialog/ga-wo-submit-report-dialog.component';
import { WorkOrderDocumentDialogService } from '../dialogs/work-order-document-dialog/work-order-document-document.service';
import { FilterableService } from '../../filterable-service';

const DISABLED_ID = 'bulk-delete';
const DATE_FORMAT = 'MM/dd/yyyy';

@Component({
  selector: 'work-orders-search',
  templateUrl: './work-orders-search.component.html',
  styleUrls: ['../work-orders.component.scss']
})
export class WorkOrdersSearchComponent extends DataGridTemplate implements OnInit, OnDestroy {
  columns: any[];
  router: Router;
  route: ActivatedRoute;
  editForm: any;
  cgpConfirmationDialogService: CgpConfirmationDialogService;
  cgpAlertDialogService: CgpAlertDialogService;
  workOrderDocumentDialogService: WorkOrderDocumentDialogService;
  workOrdersService: WorkOrdersService;
  reportsService: ReportsService;
  workOrdersFilterService: WorkOrdersFilterService;
  bodyWorkOrderService: BodyWorkOrderService;
  gaWorkOrderService: GAWorkOrderService;
  gaProgramDetailsService: ProgramDetailsGAService;
  authService: AuthenticationService;
  module: any;
  service: any;
  form: any;
  matDialog: MatDialog;
  regions = new FilterableService();

  constructor(injector: Injector) {
    super(injector);
    this.isServerSideFiltering = true;
    this.filterable = 'menu';
    this.sortable = true;
    this.router = injector.get(Router);
    this.route = injector.get(ActivatedRoute);
    this.cgpConfirmationDialogService = injector.get(CgpConfirmationDialogService);
    this.cgpAlertDialogService = injector.get(CgpAlertDialogService);
    this.bodyWorkOrderService = injector.get(BodyWorkOrderService);
    this.gaWorkOrderService = injector.get(GAWorkOrderService);
    this.workOrdersService = injector.get(WorkOrdersService);
    this.reportsService = injector.get(ReportsService);
    this.workOrdersFilterService = injector.get(WorkOrdersFilterService);
    this.gaProgramDetailsService = injector.get(ProgramDetailsGAService);
    this.authService = injector.get(AuthenticationService);
    this.module = this.authService.getModule();
    this.matDialog = injector.get(MatDialog);
    this.workOrderDocumentDialogService = injector.get(WorkOrderDocumentDialogService);
  }

  ngOnInit() {
    this.selectableSettings.enabled = true;
    this.sortable = true;
    this.columns = this.getColumns();
    this.editForm = this.formBuilder.group({});
    this.isNotificationsEnabled = false;
    this.controls.add = false;
    this.controls.edit = false;
    this.controls.delete = false;
    this.controls.excel = false;
    this.controls.width = 205;
    this.controls.configure = true;
    this.isServerSideFiltering = true;
    this.resizable = true;
    this.setControls();
    this.modal = true;
    this.selectColumnLocked = true;
    this.height = '100%';

    this.regions = this.workOrdersFilterService.lookupData.Regions;

    this.service = this.module === 'VE_Body'
      ? this.bodyWorkOrderService
      : this.gaWorkOrderService;

    this.form = this.module === 'VE_Body'
      ? this.workOrdersService.bodyMainEditForm
      : this.workOrdersService.workOrderDetailsForm;

    this.routeByWoNumberParam();

    this.workOrdersService.setIsReports = false;
    this.workOrdersService.isReportsNew = true;
    this.workOrdersFilterService.programs = null;
  }

  ngOnDestroy() {
    this.workOrdersService.setIsSearch = false;
    this.workOrdersService.setIsReports = false;
    this.workOrdersService.resetGridView();
  }

  private routeByWoNumberParam() {
    // Look for route params, if found open View Workorder
    const viewWoFromRouteParam = (param) => {

      this.gridState.filter = {
        logic: 'and',
        filters: [{
          logic: 'and',
          filters: [{field: 'WorkOrderNumber', operator: 'contains', value: `${param}`}]
        }]
      };

      this.workOrdersService.getData(this.gridState, true).then(value => {
        if (value.data) {
          this.workOrdersService.setIsSearch = true;
          this.workOrdersService.isSearchNew = true;
          const filteredArray = value.data.filter(element => {
            return element.WorkOrderNumber === param;
          });

          if (filteredArray.length === 1) {
            this.workOrdersFilterService.searchCriteria = {TextSearch: param};
            this.router.navigate(['/VE/Work-Orders/Search']);
          }
        }
      });
    };

    this.route.paramMap.subscribe(paramMap => {
      const param = paramMap.get('work-order-number');
      if (param !== null) {
        const isBodyUrl = this.router.url.includes("Body");
        const module = this.authService.getModule();
        const user = this.authService.getUser();
        const userModules = user.ModuleClaims;

        if (isBodyUrl && module !== 'VE_Body' && userModules.length === 2) {
          this.authService.switchModule(this.router.url);
        } else {
          viewWoFromRouteParam(param);
        }
      }
    });
  }

  createLookupDataCache = (): Promise<any> => {
    const searchDto = { AssignedOnly: false, UnAssignedOnly: false };

    const response = this.workOrdersService.options.isShowMyWorkOrders
      ? this.service.search(searchDto, '/GetInbox', true, this.workOrdersService.getSearchParams(this.gridState, false))
      : this.service.search(searchDto, '/Search', true, this.workOrdersService.getSearchParams(this.gridState, false));

    return response.then(data => {
      if (data) {
        this.workOrdersFilterService.lookupDataObjects =
          data.BodyWOSearchLookupData ||
          data.GAWoSearchLookupData;
      }
    });
  }

  private readonly clearFilters = () => {
    this.workOrdersService.regionFilterForm.reset();
    this.workOrdersService.regionFilter = undefined;
    delete this.gridState.filter;
    this.refresh();
  }

  loadGrid(): Promise<any> {
    this.workOrdersService.options.isShowMyWorkOrders = false;
    return this.workOrdersService.getData(this.gridState);
  }

  read(opts: any): Promise<any> {
    opts.force = this.workOrdersService.isSearchNew;
    if (this.workOrdersService.isSearchNew) {
      this.workOrdersService.isSearchNew = false;
    }
    return this.loadGrid();
  }

  add = () => {
    this.service.save(null, true, '/CreateNew')
      .then(response => {
        this.form.get('Id').setValue(response.Id);
        this.form.get('ProjectId').setValue(response.ProjectId);
        this.form.get('ProjectVersion').setValue(response.ProjectVersion);
        this.form.get('StatusId').setValue(response.StatusId);
        this.router.navigate([this.workOrdersService.buildWorkOrderRoute(true)]);
      });
  }

  addMultiple = () => {
    this.workOrdersService.setIsAddMultipleWO = true;
    this.router.navigate([this.workOrdersService.buildWorkOrderRoute(false, true)]);
  }

  editWO = (button: any, dataItem: any) => {
    if (this.module === 'VE_Body') {
      this.workOrdersService.editBodyWO(dataItem);
    } else {
      this.workOrdersService.editGAWO(dataItem);
    }
  }

  copy = (button: any, dataItem: any) => {
    const options = {
      title: `Copy ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Order`,
      yesLabel: 'Copy',
      noLabel: 'Cancel',
      description: 'Select Copy Option:',
      options: [
        {
          id: 'createNewWO',
          text: `Create New ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Order`,
          value: 'NEW'
        },
        {
          id: 'associateWO',
          text: `Associate ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Order with existing Project`,
          value: 'ASSOCIATED'
        },
      ],
    };

    const dialogRef = this.matDialog.open(
      WorkOrderCopyDialogComponent,
      { data: options });

    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.isLoading.next(true);

          this.service.save(null, true, `/CopyWorkOrder/${dataItem.Id}?copyType=${result}`, true)
            .then(response => {
              if (this.module === 'VE_Body') {
                this.workOrdersService.copyBodyWO(response);
                this.isLoading.next(false);
              } else {
                this.workOrdersService.copyGAWO(response)
                  .then(() => this.isLoading.next(false));
              }
            });
        }
      });
  }

  submitReport = (button: any, dataItem: any) => {
    const dialog = this.module === 'VE_Body' ? BodyWoSubmitReportDialogComponent : GaWoSubmitReportDialogComponent;
    const form = this.module === 'VE_Body' ? this.workOrdersService.bodyWoSubmitReportForm : this.reportsService.editForm;
    const url = this.module === 'VE_Body' ? '/SubmitReport/' : '/SubmitReport?workOrderId=';
    const date = new Date(dataItem.PlannedCompletionDate);
    const data = {
      title: `Submit Report for Work Order: ${dataItem.WorkOrderNumber}`,
      yesLabel: 'Submit',
      noLabel: 'Cancel',
      woStatus: dataItem.Status,
      woStatusId: dataItem.StatusId,
      plannedCompletionDate: date.toLocaleDateString(),
    };

    const dialogRef = this.matDialog.open(dialog, { data });
    form.reset(dataItem);

    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.isLoading.next(true);
          return this.service.save(result, false, url + dataItem.Id)
            .then(response => {
              this.isLoading.next(false);
              this.workOrdersService.displaySnackbar(response, 'submit-report');
              this.refresh();
            });
        }
      });
  }

  deleteWO = (button: any, dataItem: any) => {
    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: 'Delete Confirmation',
      message: `Are you sure you want to delete this Work Order?`,
      alert: 'danger',
      onYesClick: () => {
        this.isLoading.next(true);

        this.service.remove(`/${dataItem.Id}`, false)
          .then(response => {
            this.workOrdersService.displaySnackbar(response, 'delete');
            this.refresh();
          }).catch(() => this.refresh());

        this.cgpConfirmationDialogService.closeConfirmationDialog();
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    });
  }

  bulkDeleteConfirmation = () => {
    const msg = this.selectedRows.length === 1
      ? `Are you sure you want to delete this Work Order?`
      : `Are you sure you want to delete these ${this.selectedRows.length} Work Order(s)?`;

    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: 'Delete Confirmation',
      message: msg,
      alert: 'danger',
      onYesClick: () => {
        this.isLoading.next(true);
        this.bulkDelete();
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    });
  }

  readonly isEnabled = (id: string, dataItem: any): boolean => {
    if (id === 'clearFilters') {
      return this.gridState.filter !== undefined;
    }
    return true;
  }

  readonly isDisabled = (id: string, dataItem: any): boolean => {
    if (id === DISABLED_ID) {
      return !this.isBulkDeleteValid;
    }
    return false;
  }

  public get isBulkDeleteValid(): boolean {
    return this.selectedRows.length > 0;
  }

  bulkDelete = (): Promise<any> => {
    const ids: any[] = [];

    this.selectedRows.forEach(element => {
      ids.push(element.dataItem.Id);
    });

    return this.service.save(ids, false, '/BulkDelete', false)
      .then(response => {
        this.workOrdersService.displaySnackbar(response, DISABLED_ID);
        this.refresh();
      }).catch(e => {
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: e.error,
          alert: 'danger',
          closeLabel: 'OK',
        });
        this.isLoading.next(false);
      });
  }

  excelExport = (grid: any): void => {
    grid.visibleColumns._results.shift(); // removes Checkbox column
    grid.visibleColumns._results.shift(); // removes Actions column

    const visibleColumns: any = [];
    grid.visibleColumns._results.forEach(element => {
      visibleColumns.push(element.field);
    });

    this.workOrdersService.exportToExcel(this.gridState, visibleColumns);
  }

  viewWO = (button: any, dataItem: any) => {
    if (this.module === 'VE_Body') {
      this.workOrdersService.viewBodyWO(dataItem);
    } else {
      this.workOrdersService.viewGAWO(dataItem);
    }
  }

  back = () => {
    this.workOrdersService.regionFilterForm.reset();
    this.workOrdersService.regionFilter = undefined;
    this.workOrdersService.setIsSearch = false;
    this.workOrdersService.setIsReports = false;
    this.workOrdersService.isSearchNew = true;
    this.workOrdersService.isReportsNew = true;
    this.workOrdersService.options.isShowMyWorkOrders = true;
    this.workOrdersFilterService.programs = null;
    this.workOrdersFilterService.searchCriteria = null;
    this.router.navigate(['/VE/Work-Orders']);
  }

  /**
   * Displays a dialog where the user can select Search criteria
   * for which they want to view Work Orders - is basically a 
   * filter on the Work Order grid.
   * This dialog is displayed when the user clicks on the
   * 'Search' button
   */
  private loadSearchDialog(): Promise<any> {
    this.workOrdersService.setIsSearch = true; // allows search filter to be applied to grid
    this.workOrdersService.options.isShowMyWorkOrders = false; // checks if the search dialog has been loaded for the first time. If not, the grid needs to be refreshed with new filters.
    const data = {
      title: 'Search Work Orders',
      yesLabel: 'Search',
      noLabel: 'Cancel',
    };

    const dialogRef = this.matDialog
      .open(WorkOrderSearchDialogComponent, { data, width: '750px' });

    return dialogRef.afterClosed().toPromise()
      .then(result => {
        if (result) {
          const searchCriteria = result;
          if (searchCriteria) {
            this.workOrdersFilterService.searchCriteria = searchCriteria;
            this.gridState.skip = 0; // start at page 1
            this.refresh();
          }
        }
      });
  }

  /**
   * Checks if the user has the permissions to copy a work order. Permissions are
   * the user has correct region and secure programs for work order. If they are
   * an admin, or the work order is in draft, these rules do not apply.
   *
   * @memberof WorkOrdersComponent
   */
  checkCopy = (button: any, dataItem: any) => {
    this.service.read(`/CheckSecureWorkOrder/${dataItem.Id}`)
    .then(result => {
      if (result !== true) {
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: `User does not have sufficient program access to copy this work order.`,
          alert: 'danger',
          closeLabel: 'OK',
        });
        this.isLoading.next(false);
      } else {
        this.copy(button, dataItem);
      }
    });
  }

  /**
   * Checks if the user has the permissions to view a work order. Permissions are
   * the user has correct region and secure programs for work order. If they are
   * an admin, or the work order is in draft, these rules do not apply.
   *
   * @memberof WorkOrdersComponent
   */
  checkViewWO = (button: any, dataItem: any) => {
    this.service.read(`/CheckSecureWorkOrder/${dataItem.Id}`)
    .then(result => {
      if (result !== true) {
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: `User does not have sufficient program access to view this work order.`,
          alert: 'danger',
          closeLabel: 'OK',
        });
        this.isLoading.next(false);
      } else {
        this.viewWO(button, dataItem);
      }
    });
  }

  /**
   * Checks if the user has the permissions to submit a report for a work order. Permissions are
   * the user has correct region and secure programs for work order. If they are
   * an admin, or the work order is in draft, these rules do not apply.
   *
   * @memberof WorkOrdersComponent
   */
  checkSubmitReport = (button: any, dataItem: any) => {
    this.service.read(`/CheckSecureWorkOrder/${dataItem.Id}`)
    .then(result => {
      if (result !== true) {
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: `User does not have sufficient program access to submit reports for this work order.`,
          alert: 'danger',
          closeLabel: 'OK',
        });
        this.isLoading.next(false);
      } else {
        this.submitReport(button, dataItem);
      }
    });
  }

  /**
   * Checks if the user has the permissions to edit a work order. Permissions are
   * the user has correct region and secure programs for work order. If they are
   * an admin, or the work order is in draft, these rules do not apply.
   *
   * @memberof WorkOrdersComponent
   */
  checkEditWO = (button: any, dataItem: any) => {
    this.service.read(`/CheckSecureWorkOrder/${dataItem.Id}`)
    .then(result => {
      if (result !== true) {
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: `User does not have sufficient program access to edit this work order.`,
          alert: 'danger',
          closeLabel: 'OK',
        });
        this.isLoading.next(false);
      } else {
        this.editWO(button, dataItem);
      }
    });
  }

  private setControls() {
    this.controls.customToolBarButtons = [
      {
        id: 'add-single',
        text: `Add New`,
        title: `Create a single new ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Order`,
        class: 'btn btn-primary',
        callback: this.add,
        isShow: this.authService.isClaimValid(['Administrator', 'Manager', 'Lead', 'Engineer', 'User'])
      },
      {
        id: 'add-multiple',
        text: 'Add Multiple',
        title: `Create a multiple new ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Orders`,
        class: 'btn btn-primary',
        callback: this.addMultiple,
        isShow: this.authService.isClaimValid(['Administrator', 'Lead'])
      },
      {
        id: DISABLED_ID,
        text: `Bulk Delete`,
        title: `Delete multiple ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Orders`,
        class: 'btn btn-danger',
        callback: this.bulkDeleteConfirmation,
        isShow: this.authService.isClaimValid(['Administrator'])
      },
      {
        id: 'excel-export',
        text: `Export to Excel`,
        title: `Export ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Orders to Excel`,
        class: 'btn btn-secondary',
        callback: this.excelExport,
        isShow: this.authService.isClaimValid(['Administrator', 'Manager', 'Lead', 'Engineer', 'User'])
      },
      {
        id: 'search',
        text: 'Search',
        title: 'Search',
        class: 'btn btn-secondary',
        callback: () => this.loadSearchDialog()
      },
      {
        id: 'clearFilters',
        text: 'Clear Filters',
        title: 'Clear selected filters',
        class: 'btn-secondary float-right',
        callback: this.clearFilters
      },
    ];

    // Action buttons in grid
    this.controls.customButtons = [
      {
        id: 'copy',
        title: `Copy a ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Order`,
        callback: this.checkCopy,
        iconClass: 'fa fa-clone',
        isShow: this.authService.isClaimValid(['Administrator', 'Manager', 'Lead', 'Engineer', 'User'])
      },
      {
        id: 'edit',
        title: `Edit a ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Order`,
        callback: this.checkEditWO,
        iconClass: 'fa fa-edit'
      },
      {
        id: 'delete',
        title: `Delete a ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Order`,
        callback: this.deleteWO,
        iconClass: 'fa fa-trash',
      },
      {
        id: 'view',
        title: `View a ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Order`,
        callback: this.checkViewWO,
        iconClass: 'fa fa-external-link',
        isShow: this.authService.isClaimValid(['Administrator', 'Manager', 'Lead', 'Engineer', 'User'])
      },
      {
        id: 'report',
        title: `Submit a ${this.module === 'VE_GA' ? 'GA' : 'Body'} Work Order report`,
        callback: this.checkSubmitReport,
        iconClass: 'fa fa-bar-chart',
        isShow: this.authService.isClaimValid(['Administrator', 'Manager', 'Lead', 'Engineer', 'User'])
      }
    ];
  }

  private readonly openWorkOrderDocumentDialog = (dataItem) => {
    const workOrderId = dataItem.Id;
    this.workOrderDocumentDialogService.openDialog(this.module, workOrderId);
  }

  private readonly handleGridRegionFilter = (value) => {
    this.workOrdersService.regionFilter = value;
    this.refresh();
  }

  private getColumns() {
    return this.module === 'VE_Body' ? this.getBodyColumns() : this.getGAColumns();
  }

  private getBodyColumns() {
    return [
      {
        field: 'WorkOrderNumber',
        title: 'WO #',
        width: 100,
        filterable: true,
        sortable: true,
        locked: true
      },
      {
        field: 'Status',
        title: 'Status',
        width: 102,
        filterable: true,
        sortable: true,
        locked: true,
        template: {
          type: 'dropdown',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.Statuses,
          clearFilter: this.clearFilters,
        }
      },
      {
        field: 'ProgramCode',
        title: 'Program',
        width: 280,
        filterable: true,
        sortable: true,
        locked: true,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.Programs
        }
      },
      {
        field: 'RequestTypeDescription',
        title: 'Req. Type',
        width: 95,
        filterable: true,
        sortable: true,
        locked: true,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.RequestTypes
        }
      },
      {
        field: 'DeliverablesDescription',
        width: 250,
        title: 'Deliverables',
        filterable: true,
        sortable: true,
        locked: true,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.Deliverables
        }
      },
      {
        field: 'DeliverableUrl',
        width: 95,
        title: 'Report Link',
        sortable: false,
        filterable: false,
        template: {
          type: 'body-report-href',
        }
       },
      {
        field: 'MfgStudyTitle',
        width: 250,
        title: 'Mfg Study Title',
        filterable: true,
        sortable: true,
      },
      {
        field: 'RequestorName',
        width: 180,
        title: 'Requestor',
        filterable: true,
        sortable: false,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.Requestors
        }
      },
      {
        field: 'AssignedEngineerName',
        title: 'VE Engineer',
        width: 180,
        filterable: true,
        sortable: false,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.AssignedEngineers
        }
      },
      {
        field: 'RequiredDate',
        width: 120,
        title: 'Required Date',
        sortable: true,
        filterable: true,
        template: {
          type: 'date',
          dateFormat: DATE_FORMAT
        }
      },
      {
        field: 'GateDescription',
        width: 120,
        title: 'Gate',
        filterable: true,
        sortable: true,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.Gates
        }
      },
      {
        field: 'TrackingVehicleNumberDescription',
        width: 160,
        title: 'TKV',
        filterable: true,
        sortable: true,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.TrackingVehicleNumbers
        }
      },
      {
        field: 'MbomDescription',
        title: 'mBom',
        width: 160,
        filterable: true,
        sortable: true,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.Mboms
        }
      },
      {
        field: 'RequestDate',
        title: 'Requested Date',
        width: 120,
        sortable: true,
        filterable: true,
        template: {
          type: 'date',
          dateFormat: DATE_FORMAT
        }
      },
      {
        field: 'WorkOrderComments',
        width: 350,
        title: 'Work Order Comments',
        sortable: true,
        filterable: true,
      },
      {
        field: 'PlantDescription',
        width: 200,
        title: 'Plant',
        filterable: true,
        sortable: true,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.Plants
        }
      },
      {
        field: 'VELeadName',
        width: 180,
        title: 'VE Lead',
        filterable: true,
        sortable: false,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.VELeads
        }
      },
      {
        field: 'PlannedCompletionDate',
        width: 120,
        title: 'Projected Completion',
        sortable: true,
        filterable: true,
        template: {
          type: 'date',
          dateFormat: DATE_FORMAT
        }
      },
      {
        field: 'ActualCompletionDate',
        width: 120,
        title: 'Completion Date',
        sortable: true,
        filterable: true,
        template: {
          type: 'date',
          dateFormat: DATE_FORMAT
        }
      },
      {
        field: 'StudyName',
        width: 200,
        title: 'Study Name',
        sortable: true,
        filterable: true,
      },
      {
        field: 'Files',
        width: 85,
        title: 'Files',
        template: {
          type: 'body-document-modal',
        },
        button: {
          id: 'document',
          title: `Study Instructions Attachment`,
          callback: this.openWorkOrderDocumentDialog,
          iconClass: 'fa fa-fw fa-file-text'
        },
      },
    ];
  }

  private getGAColumns() {
    return [
      {
        field: 'WorkOrderNumber',
        title: 'WO #',
        width: 100,
        filterable: true,
        sortable: true,
        locked: true
      },
      {
        field: 'ProgramCode',
        title: 'Program',
        width: 280,
        filterable: true,
        sortable: true,
        locked: true,
      },
      {
        field: 'StudyTitleDescription',
        width: 300,
        title: 'Study Title',
        locked: true,
        filterable: true,
        sortable: true,
      },
      {
        field: 'GateTargeted',
        width: 110,
        title: 'Gate Targeted',
        filterable: true,
        sortable: true,
        locked: true,
        filter: 'boolean'
      },
      {
        field: 'Files',
        width: 100,
        title: 'Files & Reports',
        template: {
          type: 'ga-document-modal',
        },
        button: {
          id: 'document',
          title: `Study Instructions Attachment`,
          callback: this.openWorkOrderDocumentDialog,
          iconClass: 'fa fa-fw fa-file-text'
        },
      },
      {
        field: 'TKV',
        width: 115,
        title: 'TKV',
        filterable: true,
        sortable: true,
      },
      {
        field: 'GateDescription',
        width: 120,
        title: 'Gate',
        filterable: true,
        sortable: true,
        template: {
          type: 'dropdown',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.Gates
        }
      },
      {
        field: 'PlantDescription',
        width: 210,
        title: 'Plant',
        filterable: true,
        sortable: true,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.Plants
        }
      },
      {
        field: 'Status',
        title: 'Status',
        width: 102,
        filterable: true,
        sortable: true,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.Statuses
        }
      },
      {
        field: 'RequestorName',
        width: 180,
        title: 'Requestor',
        filterable: true,
        sortable: false,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.Requestors
        }
      },
      {
        field: 'AssignedEngineerName',
        title: 'VE Engineer',
        width: 180,
        filterable: true,
        sortable: false,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.AssignedEngineers
        }
      },
      {
        field: 'VELeadName',
        width: 180,
        title: 'VE Lead',
        filterable: true,
        sortable: false,
        template: {
          type: 'multiselect',
          filterType: 'multiselect',
          operator: 'equals',
          service: this.workOrdersFilterService.lookupData.VELeads
        }
      },
      {
        field: 'RequestDate',
        title: 'Requested Date',
        width: 120,
        sortable: true,
        filterable: true,
        template: {
          type: 'date',
          dateFormat: DATE_FORMAT
        }
      },
      {
        field: 'RequiredDate',
        width: 120,
        title: 'Required Date',
        sortable: true,
        filterable: true,
        template: {
          type: 'date',
          dateFormat: DATE_FORMAT
        }
      },
      {
        field: 'PlannedCompletionDate',
        width: 120,
        title: 'Projected Completion',
        sortable: true,
        filterable: true,
        template: {
          type: 'date',
          dateFormat: DATE_FORMAT
        }
      },
      {
        field: 'ActualCompletionDate',
        width: 120,
        title: 'Completion Date',
        sortable: true,
        filterable: true,
        template: {
          type: 'date',
          dateFormat: DATE_FORMAT
        }
      },
      {
        field: 'WorkOrderComments',
        width: 350,
        title: 'Work Order Comments',
        sortable: true,
        filterable: true,
      },
    ];
  }

  create = (parentEditDataItem: any): void => null;
  save = (dataItem: any, isNew: boolean): Promise<any> => null;
  edit = (dataItem: any): Promise<any> => null;
  delete = (dataItem: any): Promise<any> => null;
}
